import { Feed, FeedDataItem } from '@models/feed';
import { Button, Checkbox, Input, Switch } from 'antd';
import { PlusOutlined, DeleteOutlined } from '@ant-design/icons';
import React, { useEffect, useState } from 'react';

const BOTTOM_TABBAR_TOOLTIP_TYPES: { [key: string]: string } = {
  home: '발견',
  collection: '기획전',
  lounge: '라운지',
  chat: '채팅',
  'my-page': '마이페이지',
};

export const BottomTabbarTooltipEdit: React.FC<{
  clear?: boolean;
  data?: Partial<Feed<FeedDataItem>>;
  onChange?: (data: Partial<Feed<FeedDataItem>>) => void;
}> = (props) => {
  const [changedData, setChangedData] = useState<Feed<FeedDataItem>>();
  const { data } = props;
  const item = { ...data, ...changedData };

  useEffect(() => {
    if (props.clear) {
      setChangedData(undefined);
    }
  }, [props.clear]);

  useEffect(() => {
    if (changedData) {
      props.onChange && props.onChange({ ...data, ...changedData });
    }
  }, [changedData]);

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '12px', marginTop: '12px' }}>
      {(item?.data || []).map((tooltip: any, tooltipIndex: number) => {
        return (
          <div key={tooltip.type}>
            <div
              style={{ display: 'flex', gap: '8px', alignItems: 'center', flexDirection: 'row', marginBottom: '6px' }}>
              <div style={{ fontWeight: 'bold', fontSize: '14px' }}>{BOTTOM_TABBAR_TOOLTIP_TYPES[tooltip.type]}</div>
              <div>
                <span style={{ marginRight: '4px' }}>활성:</span>
                <Switch
                  checked={tooltip.active}
                  onChange={(checked) => {
                    setChangedData((prev) => {
                      const prevData = prev?.data || item?.data || [];
                      const newData = prevData.map((tabTooltip: any, idx: number) =>
                        idx === tooltipIndex ? { ...tabTooltip, active: checked } : tabTooltip,
                      );
                      return {
                        ...data,
                        ...prev,
                        type: 'bottom-tabbar-tooltips',
                        data: newData,
                      } as Feed<FeedDataItem>;
                    });
                  }}></Switch>
              </div>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
              {(tooltip.data || []).map((tooltipItem: any, itemIndex: number) => {
                return (
                  <div key={itemIndex} style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <Checkbox
                      checked={tooltip.default === itemIndex}
                      onClick={() => {
                        setChangedData((prev) => {
                          const prevData = prev?.data || item?.data || [];
                          const isAlreadySelected = tooltip.default === itemIndex;
                          const newData = prevData.map((tabTooltip: any, idx: number) =>
                            idx === tooltipIndex
                              ? { ...tabTooltip, default: isAlreadySelected ? undefined : itemIndex }
                              : tabTooltip,
                          );
                          return {
                            ...data,
                            ...prev,
                            type: 'bottom-tabbar-tooltips',
                            data: newData,
                          } as Feed<FeedDataItem>;
                        });
                      }}
                    />
                    <Input
                      style={{ width: '400px' }}
                      value={tooltipItem.mainCopy}
                      maxLength={10}
                      placeholder="이모지,공백 포함 최대 10자"
                      onChange={(e) => {
                        setChangedData((prev) => {
                          const prevData = prev?.data || item?.data || [];
                          const newData = prevData.map((tabTooltip: any, idx: number) => {
                            if (idx === tooltipIndex) {
                              const newInnerData = (tabTooltip.data || []).map((innerItem: any, innerIdx: number) =>
                                innerIdx === itemIndex ? { ...innerItem, mainCopy: e.target.value } : innerItem,
                              );
                              return { ...tabTooltip, data: newInnerData };
                            }
                            return tabTooltip;
                          });
                          return {
                            ...data,
                            ...prev,
                            type: 'bottom-tabbar-tooltips',
                            data: newData,
                          } as Feed<FeedDataItem>;
                        });
                      }}
                    />
                    <Button
                      type="text"
                      icon={<DeleteOutlined />}
                      danger
                      onClick={() => {
                        setChangedData((prev) => {
                          const prevData = prev?.data || item?.data || [];
                          const newData = prevData.map((tabTooltip: any, idx: number) => {
                            if (idx === tooltipIndex) {
                              const newInnerData = (tabTooltip.data || []).filter(
                                (_: any, innerIdx: number) => innerIdx !== itemIndex,
                              );
                              // default 값 조정: 삭제된 항목이 default였거나 default보다 앞에 있으면 조정
                              let newDefault = tabTooltip.default;
                              if (tabTooltip.default === itemIndex) {
                                newDefault = 0; // 삭제된 항목이 default였으면 0으로 리셋
                              } else if (tabTooltip.default > itemIndex) {
                                newDefault = tabTooltip.default - 1; // default보다 앞 항목 삭제 시 -1
                              }
                              // data가 비어있으면 default를 undefined로
                              if (newInnerData.length === 0) {
                                newDefault = undefined;
                              }
                              return { ...tabTooltip, data: newInnerData, default: newDefault };
                            }
                            return tabTooltip;
                          });
                          return {
                            ...data,
                            ...prev,
                            type: 'bottom-tabbar-tooltips',
                            data: newData,
                          } as Feed<FeedDataItem>;
                        });
                      }}
                    />
                  </div>
                );
              })}
              {(tooltip.data || []).length < 6 && (
                <Button
                  type="dashed"
                  icon={<PlusOutlined />}
                  style={{ width: '428px' }}
                  onClick={() => {
                    setChangedData((prev) => {
                      const prevData = prev?.data || item?.data || [];
                      const newData = prevData.map((tabTooltip: any, idx: number) => {
                        if (idx === tooltipIndex) {
                          const newInnerData = [...(tabTooltip.data || []), { mainCopy: '' }];
                          return { ...tabTooltip, data: newInnerData };
                        }
                        return tabTooltip;
                      });
                      return {
                        ...data,
                        ...prev,
                        type: 'bottom-tabbar-tooltips',
                        data: newData,
                      } as Feed<FeedDataItem>;
                    });
                  }}>
                  추가
                </Button>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default BottomTabbarTooltipEdit;
